import { h } from "omi";

import { IconProps } from "@/wc/components";

export function RefreshClockwiseIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={width} height={height}>
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M21 10s-2.005-2.73178-3.6338-4.36176C15.7373 4.00827 13.4864 3 11 3c-4.97056 0-9 4.02944-9 9 0 4.9706 4.02944 9 9 9 4.1031 0 7.5649-2.7457 8.6482-6.5M21 10V4m0 6h-6"
      />
    </svg>
  );
}
